import { defineAsyncComponent } from 'vue';

export const workReportMicroFrontends = {
	WorkReportChartContainer: defineAsyncComponent(
		() =>
			import(
				'./components/WorkReportChartContainer/WorkReportChartContainer.vue'
			)
	),
};
